// @flow
/**
 * Fix issue where localStorage or sessionStorage are not available,
 * for example in Safari incognito Mode.
 * @param  {String} storage
 */
function fixStorage(storage) {
  if (typeof window !== 'undefined') {
    try {
      window[storage].setItem('testKey', '1')
      if (window[storage].getItem('testKey') !== '1') {
        throw new Error()
      }
      window[storage].removeItem('testKey')
    } catch (error) {
      let data = {}
      if (typeof window[storage] === 'undefined') {
        window[storage] = {}
      }

      window[storage].setItem = (id, val) => {
        data[id] = String(val)
      }
      window[storage].getItem = (id) => {
        const val = Object.prototype.hasOwnProperty.call(data, id)
        return val ? data[id] : undefined
      }
      window[storage].removeItem = (id) => delete data[id]
      window[storage].clear = () => {
        data = {}
      }
    }
  }
}

fixStorage('localStorage')
fixStorage('sessionStorage')
